// Auto-generated skeleton for ClientUnitQuota

export const ClientUnitQuota: Api.ClientUnitQuota = {
  id: 0,
  from: 0,
  to: 0,
};

